import styled from 'styled-components';

// Browser translate replaces bare text nodes, so React crashes removing them or inserting before them.
const TranslateSafeText = styled.span`
  display: contents;
`;

export default TranslateSafeText;
